import { EndpointOptions } from '@/types/endpoint.options';
import { JobEntity } from '@/entities/job.entity';
import { getAxiosInstance } from '@/client/get-axios-instance';
import type { QueueName } from '@/constants/queue';

type JobsActiveOptions = EndpointOptions & {
    queueName?: QueueName | 'all';
};

type CancelJobsPayload = {
    jobNames: string[];
    queueName?: QueueName;
    operationId?: string;
};

type CancelJobsOptions = EndpointOptions & {
    queueName?: QueueName;
};

class JobsRepository {
    private readonly _axios = getAxiosInstance('/api/jobs');

    getActive<T>(jobNames: string[], options?: JobsActiveOptions) {
        const searchParams = new URLSearchParams();

        for (const jobName of jobNames) {
            searchParams.append('jobName', jobName);
        }

        if (options?.queueName) {
            searchParams.append('queueName', options.queueName);
        }

        return this._axios.get<JobEntity<T>[]>('/active', {
            params: searchParams,
            headers: { Authorization: options?.authToken },
            signal: options?.signal,
        });
    }

    cancel(payload: CancelJobsPayload, options?: CancelJobsOptions) {
        return this._axios.post<{ canceledCount: number; operationId: string | null }>(
            '/cancel',
            {
                ...payload,
                queueName: payload.queueName || options?.queueName,
            },
            {
                headers: { Authorization: options?.authToken },
                signal: options?.signal,
            },
        );
    }
}

export const createJobsRepository = () => new JobsRepository();

export const jobsRepository = createJobsRepository();
